<!--
 * @Description: 
 * @Autor: yd
 * @Date: 2020-08-05 09:33:40
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-01-14 14:49:44
-->
<template>
  <v-card>
    <v-card-title>
      <mrc_ess_searchInput
        :isShow="true"
        v-model="search"
        @keydown="keydown"
        @change="change"
        :appendShow="false"
      ></mrc_ess_searchInput>
    </v-card-title>
    <v-card-text>
      <div class="top" :style="{ 'max-height': maxHeight + 'px' }">
        <!-- color="#E5EEFF" -->
        <v-treeview
          dense
          :search="search"
          selected-color="primary"
          :items="allList"
          color="#0f46c1"
          activatable
          :open.sync="open"
          :open-on-click="false"
          item-disabled="disabled"
          :item-text="itemText"
          :item-key="itemKey"
        >
          <template v-slot:prepend="{ open }">
            <v-icon>
              {{ open ? "mdi-folder-open" : "mdi-folder" }}
            </v-icon>
          </template>

          <template v-slot:label="{ item }">
            <span
              @click="getStaffList(item)"
              class="gesture"
              style="font-size: 12px; color: rgba(0, 0, 0, 0.78)"
              >{{ INT(item[itemText]) }}</span
            >
          </template>
        </v-treeview>
      </div>
      <!-- 员工列表 -->
      <v-card
        class="footer mt-2 pl-5 pr-4 pb-2"
        v-if="showStaffList && staffList.length"
        :loading="cardLoading"
      >
        <div
          style="color: #0f46c1; width: 200px"
          class="mb-2 mt-2 gesture"
          @click="selectAll"
        >
          <v-icon
            class="material-icons"
            :style="{
              color: !selectAllStatus ? '' : '#0f46c1',
              'font-size': '20px',
            }"
            >library_add_check</v-icon
          >
          <span
            class="ml-2"
            :style="{
              color: !selectAllStatus ? '#9e9e9e' : '#0f46c1',
              'font-size': '12px',
            }"
            >{{ $t("label_chooseStaff-selectAll") }}</span
          >
        </div>
        <div class="footer_box" :style="{ maxHeight: maxHeightFooter + 'px' }">
          <div
            class="d-flex mt-1 pl-2 align-center justify-space-between gesture"
            v-for="(item, index) in staffList"
            :key="item.uuid + index"
            :class="item.active ? 'staffactive' : ''"
            @click="detailStaff(item, index)"
            style="
              border: 1px solid rgb(236, 236, 236);
              height: 48px;
              font-size: 14px;
              border-radius: 4px;
              overflow: hidden;
            "
          >
            <slot :item="item">
              <div class="d-flex">
                <div class="ml-2 mt-1">
                  <v-img
                    style="border-radius: 50%"
                    height="24"
                    width="24"
                    :src="`https://picsum.photos/500/300?image=${5 * 5 + 10}`"
                    :lazy-src="`https://picsum.photos/10/6?image=${5 * 5 + 10}`"
                    class="grey lighten-2"
                  ></v-img>
                </div>
                <div class="d-flex ml-2" style="flex-direction: column">
                  <span
                    :style="{
                      color: item.active ? '#0F46C1' : 'rgba(0, 0, 0, 0.78)',
                      'font-size': '14px',
                    }"
                  >
                    <!-- ' \xa0 ' -->
                    {{ item.christian_name ? item.christian_name : "" }}
                    {{ item.christian_name && item.show_name ? "/" : "" }}
                    {{ item.show_name ? INT(item.show_name) : item.show_name }}
                  </span>
                  <span
                    :style="{
                      color: item.active ? '#739CE8' : 'rgba(0, 0, 0, 0.38)',
                      'font-size': '12px',
                    }"
                  >
                    {{ INT(item.job_post_name) }}
                  </span>
                </div>
              </div>
              <div v-if="item.active">
                <v-icon
                  class="material-icons mr-3"
                  v-if="item.active"
                  style="color: rgb(19, 166, 113); line-height: 42px"
                >
                  check_circle
                </v-icon>
              </div>
            </slot>
          </div>
        </div>
      </v-card>
    </v-card-text>
  </v-card>
</template>

<script>
/**
 *
 *
 *
 *
 * @detailStaff 获取员工的详情数据
 * @selectAll  选择列表中的全部员工
 * @getStaffList 发送请求。请求员工列表数据
 */
export default {
  components: {},
  props: {
    allList: {
      //树结构
      type: Array,
      default: () => [],
    },
    cardLoading: {
      //列表加载状态 默认不显示
      type: Boolean,
      default: false,
    },
    staffList: {
      //员工列表   or 渲染列表
      type: Array,
      default: () => [],
    },
    showStaffList: {
      //是否显示员工列表
      type: Boolean,
      default: true,
    },
    maxHeight: {
      type: String,
      default: "150",
    },
    maxHeightFooter: {
      type: String,
      default: "200",
    },
    itemText: {
      type: String,
    },
    itemKey: {
      type: String,
    },
  },
  data() {
    return {
      search: null, //搜索值
      caseSensitive: false, //区分大小写
      open: [1, 2],
      timeout: null,
    };
  },
  computed: {
    selectAllStatus() {
      //全选状态 默认不全选
      if (this.staffList.length > 0) {
        return this.staffList.every((item) => {
          return item.active == true;
        });
      } else {
        return false;
      }
    },
    post_and_grade() {
      if (this.staffList.post_and_grade) {
        return this.staffList.post_and_grade.indexOf(",") != -1
          ? String(this.staffList.post_and_grade).split()
          : [this.staffList.post_and_grade];
      } else {
        return [];
      }
    },
    client_and_org() {
      if (this.staffList.client_and_org) {
        return this.staffList.client_and_org.indexOf(",") != -1
          ? String(this.staffList.client_and_org).split()
          : [this.staffList.client_and_org];
      } else {
        return [];
      }
    },
    filter() {
      return this.caseSensitive
        ? (item, search, textKey) => item[textKey].indexOf(search) > -1
        : undefined;
    },
  },
  created() {},
  watch: {},
  mounted() {},

  methods: {
    keydown(v) {},
    change(v) {
      // console.log(this.search);
    },
    getStaffList(item) {
      if (this.timeout !== null) clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        // this.cardLoading = true
        // this.selectAllStatus = false
        // console.log('次数');
        this.$emit("getStaffList", item);
        // this.cardLoading = false
      }, 500);
    },
    detailStaff(val, index) {
      //点击员工获取员工详情
      this.$emit("detailStaff", val, index);
    },
    selectAll() {
      this.$emit("selectAll", this.staffList, this.selectAllStatus);
    },
  },
};
</script>

<style scoped>
.top {
  border: 2px solid #ececec;
  overflow-y: auto;
}
.footer {
  border: 2px solid #ececec;
  box-shadow: none;
}
.footer_box {
  overflow-y: auto;
}
.staffactive {
  background-color: #e5eeff;
}
.gesture:hover {
  cursor: pointer;
}
</style>
